"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* globals __PROFUMO_CONFIG__: true */
exports.appConfig = __PROFUMO_CONFIG__;



//////////////////
// WEBPACK FOOTER
// ./scripts/appConfig.ts
// module id = 605
// module chunks = 0